import consumer from "./consumer"
import { salaryOperationFailureAlertShown, markSalaryOperationFailureAlertShown } from "./salary_operation_failure_alert"
import { openMissingPfScreen } from "./pf_warning"

// Starting a run reloads the page, so the warning broadcast can arrive while
// this socket is torn down. The server also records it on the run, and this
// replays it once per run when the sheet loads.
const replayPendingPfWarning = () => {
  const holder = document.getElementById('pending-pf-warning');
  if (!holder) return;

  const payrollRunId = holder.dataset.payrollRunId;

  let designations = [];
  try {
    // JSON.parse('null') returns null without throwing, so the empty-array
    // check below has to be resilient to that on its own rather than relying
    // on this catch — an uncaught error here would abort the whole ready
    // handler, including the channel subscription below it.
    designations = JSON.parse(holder.dataset.designations || '[]');
  } catch (_) {
    return;
  }
  if (!Array.isArray(designations) || !designations.length) return;

  openMissingPfScreen(designations, payrollRunId);
};

jQuery(document).ready(function(){
  replayPendingPfWarning();

  consumer.subscriptions.create("PayrollSheetErrorsChannel", {
    received: (data) => {
      if (data.event == 'warning') {
        openMissingPfScreen(data.designations, data.payroll_run_id);
      }
      else {
        var message = ''
        if(data.event == 'salary_operation') {
          if (salaryOperationFailureAlertShown(data.payroll_run_id)) return;

          markSalaryOperationFailureAlertShown(data.payroll_run_id);
          $('.salary-operation-status').remove();
          message = `Salary ${data.operation} failed because ${data.message}, Please press OK to refresh page`
        }
        else {
          $('.salary-dispatching-status').remove();
          message = `Failed to dispatch Salary because ${data.message}, Please press OK to refresh page`
        }
        setTimeout(() => {
          if (data.message) {
            if (confirm(message)) {
              location.reload();
            }
          }
        }, 200)
      }
    }
  });
});
